import { render } from "./Appointment.vue?vue&type=template&id=59c369d8&scoped=true"
import script from "./Appointment.vue?vue&type=script&lang=ts"
export * from "./Appointment.vue?vue&type=script&lang=ts"

import "./Appointment.vue?vue&type=style&index=0&id=59c369d8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-59c369d8"

export default script